import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Footer from "./Footer"
import Navigation from "./Navigation"
import { Row, Col, Form } from "react-bootstrap"
import { ImOffice } from "react-icons/im"
import { HiOutlineMail } from "react-icons/hi"
import { FiPhoneCall } from "react-icons/fi"
import CEO from "./Images/CEO.jpg"
import CMO from "./Images/CMO.jpg"
import { sendMail } from "../services/mailservice"

const Contactus = () => {

const initialFormData = {
  name: "",
  email: "",
  mobile: "",
  message: "",
};

const [formData, setFormData] = useState(initialFormData);
const [errors, setErrors] = useState({});
const [submitting, setSubmitting] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};



   const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = 'Mobile number is required';
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = 'Enter valid 10-digit mobile number';
    }
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setSubmitting(true);
  try {
    await sendMail({
      to: formData.email,
      subject: "New Contact Request",
      templateType: "contact",
      text: JSON.stringify(formData, null, 2),
    });

    alert("Mail sent successfully ✅");

    // ✅ Clear all fields after successful submission
    setFormData(initialFormData);
    setErrors({});

    // Optional: also clear the form element itself
    e.target.reset();
  } catch (err) {
    console.error("Mail API Error:", err);
    alert("Failed to send mail ❌");
  } finally {
    setSubmitting(false);
  }
};


//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);

    const [mobilescr, setMobilescr] = useState(false)
    const [getdevwidth, setGetdevwidth] = useState("")

    useEffect(() => {

        setGetdevwidth(window.innerWidth + 'px')

        if (window.innerWidth <= 500) {
            setMobilescr(true)
        }
        //console.log(getdevwidth)

    }, [getdevwidth])


    ///////////////Render top/////////////////////
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (

        <div className="">

            {
                !mobilescr ?
                    <>
                        <Row className="mb-5">
                            <Navigation />
                        </Row>
                        <Row className="mt-5"></Row>
                        <Row className="mt-5"></Row>
                    </>
                    :
                    <Row className="">
                        <Navigation />
                    </Row>
            }

            <Row className=" contactustopbg justify_content_center">
                <Col className="">
                    <Row className="justify_content_center aboutheadingtxt">

                        Contact Us

                    </Row>

                    <Row className="justify_content_center ">
                        <Col className="justify_content_center ">

                            <span className="aboutustoptext1 mr-0"><Link to="/" className="aboutustoptext1">Home</Link></span>
                            <span className="aboutustoptext1 mx-3 mr-3">{">"}</span>
                            <span className="aboutustoptext2 ml-0">Contact us</span>
                        </Col>
                    </Row>
                </Col>
            </Row>


             {/* Backup----start------------------------*/}

            <Row className=" justify_content_center mt-5 mb-5 " >
                <Col sm={1}></Col>
                <Col className="" >

                  <form onSubmit={handleSubmit}>
      <Row className="homreqmsgrect" data-aos="fade-up">
        <Col className="mt-0">
          <Row className="homesecondtop mt-5">SEND A MESSAGE</Row>
          <Row className="homereqmsghead mt-4">Request a call back</Row>

          {/* Name */}
          <Row className="floating-label mt-5">
            <input
              className="floating-input"
              type="text"
              name="name"
              placeholder=" "
              value={formData.name}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your name *</label>
            {errors.name && <div className="text-danger">{errors.name}</div>}
          </Row>

          {/* Email */}
          <Row className="floating-label mt-4">
            <input
              className="floating-input"
              type="email"
              name="email"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Email *</label>
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </Row>

          {/* Mobile */}
          <Row className="floating-label mt-4">
            <input
              className="floating-input"
              type="text"
              name="mobile"
              placeholder=" "
              value={formData.mobile}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Mobile no *</label>
            {errors.mobile && <div className="text-danger">{errors.mobile}</div>}
          </Row>

          {/* Message */}
          <Row className="floating-label mt-4">
            <textarea
              className="floating-input"
              name="message"
              placeholder=" "
              style={{ height: '120px' }}
              value={formData.message}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your message *</label>
            {errors.message && <div className="text-danger">{errors.message}</div>}
          </Row>

          {/* Submit Button */}
          <Row className="justify_content_left mt-5">
            <button
              type="submit"
              className="homgreqmsgbtn"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </Row>
        </Col>
      </Row>
    </form>





                </Col>
                <Col className="mt-0 mx-5" data-aos="fade-left">
                    <Row className="homesecondsecwelcom mt-5">
                        CONTACT US
                    </Row>
                    <Row className="mt-5">
                        <Col xs={1}></Col>
                        <Col xs>
                            <Row className="justify_content_center">
                                <img src={CEO} alt="" className="teamimg" />
                            </Row>
                            <Row className="Teammebname justify_content_center mt-4">Pankaj Kotwani</Row>
                            <Row className="Teammebdesign justify_content_center mt-1">Founder and CEO</Row>
                        </Col>
                        <Col xs>
                            <Row className="justify_content_center">
                                <img src={CMO} alt="" className="teamimg" />
                            </Row>
                            <Row className="Teammebname justify_content_center mt-4">Aryan Kotwani</Row>
                            <Row className="Teammebdesign justify_content_center mt-1">
                                Co-Founder and CMO
                            </Row>
                            <Row className="Teammebdesign justify_content_center mt-1">Chief Marketing Officer</Row>
                        </Col>
                        <Col xs={1}></Col>
                    </Row>


                    <Row className="homesecondsechead mt-4">
                        We’d Love to Hear From You.
                    </Row>
                    <Row className="mt-4">
                        <Col xs={3} className="homesecondsecborder"></Col>
                    </Row>
                    {/* <Row className="homesecondsecdesc mt-4 mx-2">
                        We deeply care for our clients, firmly believe in our people and are Passionate about our quality of services. We are equipped to meet the changing demands of the corporate and non-corporate entities with our trained personnel, capable of rendering wide spectrum of services.
                    </Row> */}
                    <Row className="mt-4">
                        <Col sm className="">
                            <Row>
                                <Col xs={3} className='contactusicon'>
                                    <FiPhoneCall />
                                </Col>
                                <Col>
                                    <Row className="contactusheads  mt-3">
                                        Call Us
                                    </Row>
                                    <Row className="contactusdesc  mt-0">
                                        +1 440 812 9027
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm>
                            <Row>
                                <Col xs={3} className='contactusicon'>
                                    <HiOutlineMail />
                                </Col>
                                <Col>
                                    <Row className="contactusheads  mt-3">
                                        Email Address
                                    </Row>
                                    <Row className="contactusdesc  mt-0">
                                        pankaj@logisticsaios.app
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col sm>
                            <Row>
                                <Col xs={3} className='contactusicon'>
                                    <ImOffice />
                                </Col>
                                <Col>
                                    <Row className="contactusheads  mt-2">
                                        Visit
                                    </Row>
                                    <Row className="contactusdesc  mt-0">
                                        Pankaj Kotwani<br />32200 Miles Rd<br />Solon, OH<br />
                                        44139, USA
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm></Col>
                    </Row>
                </Col>

            </Row>



  {/* Backup----end------------------------*/}



            <Row className="footermargin  ">
                <Footer />
            </Row>

        </div>
    )
}

export default Contactus